import { render, staticRenderFns } from "./LoginResetPassword.vue?vue&type=template&id=ba0f786e"
import script from "./LoginResetPassword.vue?vue&type=script&lang=js"
export * from "./LoginResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports